import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import axios from 'axios';
import { store } from './store';
// axios.defaults.baseURL = 'https://onpr.bi/onpr_api/publihttps://www.youtube.com/watch?v=8WPGQ5zd-XAc/api';
//axios.defaults.baseURL = 'https://api.onpr.bi/api';
axios.defaults.baseURL = 'https://api.onpr.bi/api';
axios.defaults.headers.common['Authorization'] = 'AUTH TOKEN';
//axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.interceptors.request.use(request => {
  //console.log(request);
  // Edit request config
  return request;
}, error => {
  // console.log(error);
  return Promise.reject(error);
});

axios.interceptors.response.use(response => {
  //  console.log(response);
  // Edit response config
  return response;
}, error => {
  // console.log(error);
  return Promise.reject(error);
});


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

